var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import axios from 'axios';
import axiosRetry from 'axios-retry';
import { SubmitResult } from "./model/SubmitResult";
import { SubmitBody } from "./model/SubmitBody";
const DEFAULT_WEBFORMS_ENDPOINT = 'https://webforms.brynlabs.com/api';
export class Form {
  /**
   * Form Constructor. Recaptcha must be loaded before this method is called to use recaptcha.
   *
   * @param formToken Your formToken from the Webforms configuration.
   * @param recaptchaPublicKey Publickey from your recaptcha
   */
  constructor(formToken, recaptchaPublicKey) {
    this.webformsEndpoint = DEFAULT_WEBFORMS_ENDPOINT;
    this.formToken = formToken;
    this.useRecaptcha = !!recaptchaPublicKey;
    this.recaptchaPublicKey = recaptchaPublicKey;
    if (this.useRecaptcha && typeof grecaptcha === 'undefined') {
      console.error("window.grecaptcha not found. You probably haven't installed the recaptcha v3 script. Webforms will not be able to submit your form.\nPlease add the following script tag to your page: \"<script src=\"https://www.google.com/recaptcha/api.js?render=".concat(this.recaptchaPublicKey, "\"></script>\""));
    }
  }
  /**
   * Override the default webforms endpoint. (usually only used for testing)
   *
   * @param value Url of the webforms endpoint without following slash (e.g.: https://webforms.brynlabs.com/api)
   */
  setWebformsEndpoint(value) {
    this.webformsEndpoint = value;
  }
  /**
   * Submit data to the form.
   *
   * @param data Data matching your configured schema.
   */
  submit(data) {
    return __awaiter(this, void 0, void 0, function* () {
      let recaptchaToken;
      if (this.useRecaptcha) {
        recaptchaToken = yield new Promise((resolve, reject) => {
          grecaptcha.ready(() => {
            grecaptcha.execute(this.recaptchaPublicKey, {
              action: 'submit'
            }).then(token => {
              resolve(token);
            }).catch(err => {
              console.error(err);
              reject(err);
            });
          });
        });
      }
      const client = axios.create({
        baseURL: this.webformsEndpoint
      });
      axiosRetry(client, {
        retries: 5,
        retryDelay: axiosRetry.exponentialDelay,
        retryCondition: e => {
          return axiosRetry.isRetryableError(e);
        }
      });
      const resPromise = client.post("/submit/".concat(this.formToken), new SubmitBody(data, recaptchaToken));
      return resPromise.then(res => new SubmitResult(res)).catch(err => {
        var _a;
        return new SubmitResult((_a = err.response) === null || _a === void 0 ? void 0 : _a.data, true);
      });
    });
  }
}